document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-close-details]').forEach((button) => {
    button.addEventListener('click', () => {
      const details = button.closest('details');
      if (details) {
        details.removeAttribute('open');
        details.querySelector('summary')?.focus();
      }
    });
  });

  document.querySelectorAll('[data-mobile-menu]').forEach((details) => {
    const summary = details.querySelector('[data-menu-summary]');
    details.addEventListener('toggle', () => {
      const isOpen = details.open;
      summary?.setAttribute('aria-expanded', String(isOpen));
      summary?.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
      if (isOpen) details.querySelector('[data-close-details]')?.focus();
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details[open]').forEach((details) => {
      details.removeAttribute('open');
      details.querySelector('summary')?.focus();
    });
  });

  document.querySelectorAll('[data-hero-video-toggle]').forEach((button) => {
    const media = button.closest('[data-responsive-hero-media]');
    const videos = [...(media?.querySelectorAll('video') || [])];
    const playIcon = button.querySelector('[data-hero-play]');
    const pauseIcon = button.querySelector('[data-hero-pause]');
    const mobileViewport = window.matchMedia('(max-width: 820px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let userPaused = false;

    if (!videos.length) {
      button.hidden = true;
      return;
    }

    const activeVideo = () => videos.find((video) => getComputedStyle(video).display !== 'none') || videos[0];

    const updateVideoControl = () => {
      const video = activeVideo();
      const isPlaying = !video.paused;
      button.setAttribute('aria-label', isPlaying ? 'Pause background video' : 'Play background video');
      button.setAttribute('aria-pressed', String(isPlaying));
      playIcon.hidden = isPlaying;
      pauseIcon.hidden = !isPlaying;
    };

    const syncResponsiveVideo = () => {
      const currentVideo = activeVideo();
      videos.forEach((video) => {
        if (video !== currentVideo) video.pause();
      });
      if (!userPaused && !reducedMotion.matches) currentVideo.play().catch(updateVideoControl);
      updateVideoControl();
    };

    button.addEventListener('click', () => {
      const video = activeVideo();
      if (video.paused) {
        userPaused = false;
        video.play().catch(updateVideoControl);
      } else {
        userPaused = true;
        videos.forEach((item) => item.pause());
      }
    });

    videos.forEach((video) => {
      video.addEventListener('play', updateVideoControl);
      video.addEventListener('pause', updateVideoControl);
    });

    reducedMotion.addEventListener?.('change', (event) => {
      if (event.matches) {
        videos.forEach((video) => video.pause());
      } else if (!userPaused) {
        activeVideo().play().catch(updateVideoControl);
      }
      updateVideoControl();
    });
    mobileViewport.addEventListener?.('change', syncResponsiveVideo);
    syncResponsiveVideo();
  });

  let hashTarget = null;
  if (window.location.hash) {
    try {
      hashTarget = document.querySelector(window.location.hash);
    } catch (_error) {
      hashTarget = null;
    }
  }
  const successMessage = hashTarget?.querySelector('[data-waitlist-success], [data-contact-success]')
    || document.querySelector('[data-contact-success]')
    || document.querySelector('[data-waitlist-success]');
  if (successMessage) {
    window.requestAnimationFrame(() => {
      successMessage.focus({ preventScroll: true });
      successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
});

// Bind once on initial load and when Shopify refreshes a section in the editor.
function initializeRoveaPreviews(root = document) {
  root.querySelectorAll('[data-product-preview]').forEach((card) => {
    if (card.dataset.previewBound) return;
    card.dataset.previewBound = 'true';
    const image = card.querySelector('.core-product__image img');
    const swatches = [...card.querySelectorAll('[data-preview-swatch]')];
    const status = card.querySelector('[data-preview-status]');
    let requestId = 0;
    const select = (swatch) => {
      if (!image || !swatch.dataset.image) return;
      const currentRequest = ++requestId;
      const pending = new Image();
      card.setAttribute('aria-busy', 'true');
      pending.onload = () => {
        if (currentRequest !== requestId) return;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = swatch.dataset.image;
        image.alt = `${swatch.dataset.colour} ${card.dataset.productPreview} design preview`;
        swatches.forEach((item) => {
          const active = item === swatch;
          item.setAttribute('aria-checked', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        status.textContent = `Design preview · ${swatch.dataset.colour}`;
        card.removeAttribute('aria-busy');
      };
      pending.onerror = () => {
        if (currentRequest !== requestId) return;
        card.removeAttribute('aria-busy');
        status.textContent = 'Preview unavailable. Please try another colour.';
      };
      pending.src = swatch.dataset.image;
    };
    swatches.forEach((swatch, index) => {
      swatch.addEventListener('click', () => select(swatch));
      swatch.addEventListener('keydown', (event) => {
        let next = index;
        if (['ArrowRight','ArrowDown'].includes(event.key)) next = (index + 1) % swatches.length;
        else if (['ArrowLeft','ArrowUp'].includes(event.key)) next = (index - 1 + swatches.length) % swatches.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = swatches.length - 1;
        else return;
        event.preventDefault();
        swatches[next].focus();
        select(swatches[next]);
      });
    });
  });
}
document.addEventListener('DOMContentLoaded', () => {
  initializeRoveaPreviews();
  document.querySelectorAll('[data-mobile-menu] a').forEach((link) => {
    link.addEventListener('click', () => link.closest('details')?.removeAttribute('open'));
  });
});
document.addEventListener('shopify:section:load', (event) => initializeRoveaPreviews(event.target));
